import Vue from 'vue';
import App from './App.vue';
import './variable/components';

Vue.config.devtools = true;
Vue.config.productionTip = false;
// eslint-disable-next-line func-names
Vue.config.errorHandler = function (err) {
  console.error(err);
  // eslint-disable-next-line no-param-reassign
  err = err || { stack: '' };
  if (window.monitor) {
    window.monitor.report({
      level: 'error',
      error: 'js',
      url: window.location.href,
      msg: `vueCaptureError --> ${err.message}`,
      stack: err.stack.slice(0, 300),
    });
  }
};
new Vue({
  render: h => h(App),
}).$mount('#app');
